
import store from '../store'
import { getToken } from '@/utils/auth'
import { getUuid, setUuid } from '@/utils/storage'
import axios from 'axios'
import global from './global'

const service = axios.create({




baseURL: `${global.apiUrl}/aa/v1`,

timeout: 15000 
})

service.defaults.retry = 3
service.defaults.retryDelay = 1000


service.interceptors.request.use(request => {


const token = getToken()
if (token) {
request.headers['token'] = token
} else {
let uuid = getUuid()
if (uuid) {
request.headers['uuid'] = uuid
} else {
uuid = Date.parse(new Date()).toString() + Math.random().toString()
setUuid(uuid)
request.headers['uuid'] = uuid
}
}
return request
})


service.interceptors.response.use(response => {


return response
}, error => {
store.commit('UPDATE_LOADING_STATUS', { isLoading: false })
return Promise.reject(error)
})


export default service



// WEBPACK FOOTER //
// ./src/utils/request_no_error.js